'use strict';

document.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth >= 768) {
    const videoContainer = document.getElementById('video-container');
    const videoUrl = videoContainer ? videoContainer.getAttribute('data-url') : null;
    const videoId = videoUrl ? getVimeoVideoId(videoUrl) : null;
    const thumbnail = document.getElementById('video-thumbnail');

    if (videoId) {
      window.addEventListener('load', () => {
        const iframe = document.createElement('iframe');
        iframe.src = `https://player.vimeo.com/video/${videoId}?background=1&autoplay=1&loop=1&byline=0&title=0`;
        iframe.style.border = '0';
        iframe.allowFullscreen = true;
        iframe.webkitAllowFullScreen = true;
        iframe.mozAllowFullScreen = true;

        // Hide the thumbnail and show the video
        videoContainer.style.display = 'block';
        videoContainer.appendChild(iframe);
      });
    }
  }
});

function getVimeoVideoId(url) {
  const regex = /(?:https?:\/\/)?(?:www\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/(?:\w+\/)?|album\/(?:\d+\/)?|video\/)?(\d+)(?:$|\/|\?)/;
  const matches = url.match(regex);
  return matches ? matches[1] : null;
}
